(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hot-events"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hot-events')) {
    class HotEvents extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.locale = this.dataset.locale || 'de';
        this.words = Object.fromEntries([...this.querySelectorAll('[data-word]')].map(node => [node.dataset.word,node.textContent]));
        const blocks = [...this.querySelectorAll('[data-event]')].map(node => ({...node.dataset}));
        this.events = blocks.filter(block => block.kind==='event'||block.kind==='series');
        this.overrides = blocks.filter(block => block.kind==='registration');
        const parts = new Intl.DateTimeFormat('en-CA',{timeZone:'Europe/Zurich',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',hourCycle:'h23'}).formatToParts(new Date());
        const clock = Object.fromEntries(parts.map(p => [p.type,p.value]));
        this.today = `${clock.year}-${clock.month}-${clock.day}`;
        this.now = `${this.today}T${clock.hour}:${clock.minute}`;
        this.month = this.today.slice(0,7);
        this.view = 'list';
        this.filter = 'all';
        this.dialog = this.querySelector('dialog');
        const filters = this.querySelector('[data-filter]');
        [...new Set(this.events.map(e => e.game))].filter(Boolean).forEach(game => {
          const option = this.node('option','',this.game(game)); option.value = game; filters.append(option);
        });
        filters.addEventListener('change',() => { this.filter = filters.value; this.render(); });
        this.querySelectorAll('[data-view]').forEach(button => button.addEventListener('click',() => { this.view = button.dataset.view; this.render(); }));
        this.querySelectorAll('[data-month-step]').forEach(button => button.addEventListener('click',() => {
          const date = this.date(this.month+'-01'); date.setUTCMonth(date.getUTCMonth()+Number(button.dataset.monthStep)); this.month = this.iso(date).slice(0,7); this.render();
        }));
        this.querySelector('[data-current]').addEventListener('click',() => { this.month=this.today.slice(0,7); this.render(); });
        this.querySelector('[data-close]').addEventListener('click',() => this.dialog.close());
        this.dialog.addEventListener('click',event => { if(event.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)this.dialog.close();} });
        this.querySelectorAll('[data-controls]').forEach(node => node.hidden=false);
        this.renderFeature();
        this.render();
      }
      node(tag,className,text) { const node=document.createElement(tag); if(className)node.className=className;if(text!==undefined)node.textContent=text;return node; }
      date(value) { if(!/^\d{4}-\d{2}-\d{2}$/.test(value||''))return null;const date=new Date(value+'T12:00:00Z');return Number.isNaN(date.valueOf())||this.iso(date)!==value?null:date; }
      iso(date) { return date.toISOString().slice(0,10); }
      format(value,options) { return new Intl.DateTimeFormat(this.locale,{...options,timeZone:'UTC'}).format(this.date(value)); }
      game(key) { return this.words['game_'+key]||this.words.game_other; }
      entry(value) { return /^(gratis|kostenlos|free)$/i.test((value||'').trim())?this.words.free:value; }
      seriesKey(value) { return (value||'').trim().toLowerCase(); }
      future(event) { return event.date>this.today || event.date===this.today&&(!event.time || event.date+'T'+event.time>=this.now); }
      occurrences(start,end) {
        const list=[];
        this.events.forEach(event => {
          if(event.kind==='event') { if(this.date(event.date)&&event.date>=start&&event.date<=end)list.push(event);return; }
          if(event.kind!=='series')return;
          const first=this.date(event.start);const last=this.date(event.end);if(!first)return;
          const day={sun:0,mon:1,tue:2,wed:3,thu:4,fri:5,sat:6}[event.weekday];if(day===undefined)return;
          first.setUTCDate(first.getUTCDate()+(day-first.getUTCDay()+7)%7);
          const period=(event.interval==='2'?14:7)*86400000;
          const lower=this.date(start);const upper=this.date(end);const limit=last&&last<upper?last:upper;
          let time=first.valueOf()+Math.max(0,Math.ceil((lower-first)/period))*period;
          for(;time<=limit.valueOf();time+=period){
            const date=this.iso(new Date(time));
            const key=this.seriesKey(event.series);
            const unique=key&&this.events.filter(item=>item.kind==='series'&&this.seriesKey(item.series)===key).length===1;
            const registration=unique?this.overrides.findLast(item=>this.seriesKey(item.series)===key&&item.date===date):null;
            list.push({...event,kind:'event',date,link:registration?.link||''});
          }
        });
        return list.sort((a,b)=>(a.date+(a.time||'')).localeCompare(b.date+(b.time||'')));
      }
      upcoming() {
        const end=new Date(this.date(this.today));end.setUTCFullYear(end.getUTCFullYear()+1);
        const dated=this.events.filter(e=>e.kind==='event'&&this.date(e.date)&&this.future(e));
        const series=this.occurrences(this.today,this.iso(end)).filter(e=>e.start&&this.future(e));
        return [...dated,...series].sort((a,b)=>(a.date+(a.time||'')).localeCompare(b.date+(b.time||'')));
      }
      link(event) {
        if(!event.link)return null;
        try { const url=new URL(event.link,location.origin);if(!['https:','http:'].includes(url.protocol))return null; }
        catch { return null; }
        const link=this.node('a','he-text-link',this.words.details);link.href=event.link;return link;
      }
      meta(event,className) {
        const meta=this.node('p',className);
        if(event.time)meta.append(this.node('span','',event.time));
        if(event.entry)meta.append(this.node('span','',this.entry(event.entry)));
        return meta;
      }
      eventRow(event) {
        const row=this.node('article','he-event');const date=this.node('time','he-event__date');date.dateTime=event.date;
        date.append(this.node('strong','',this.format(event.date,{day:'2-digit'})),this.node('span','',this.format(event.date,{month:'short',year:'numeric'})));
        const copy=this.node('div','he-event__copy');copy.append(this.node('p','he-event__game',this.game(event.game)),this.node('h3','',event.title),this.meta(event,'he-event__meta'));
        row.append(date,copy);const link=this.link(event);if(link)row.append(link);return row;
      }
      renderFeature() {
        const feature=this.querySelector('[data-feature]');const event=this.upcoming()[0];feature.replaceChildren();
        if(!event){feature.append(this.node('h2','',this.words.stay_tuned),this.node('p','',this.words.no_upcoming));return;}
        const date=this.node('div','he-feature__date');const time=this.node('time','');time.dateTime=event.date;
        time.append(this.node('span','',this.format(event.date,{weekday:'long'})),this.node('span','',this.format(event.date,{month:'long',year:'numeric'})));
        date.append(this.node('strong','',this.format(event.date,{day:'2-digit'})),time);
        feature.append(date,this.node('p','he-feature__game',this.game(event.game)),this.node('h2','',event.title),this.meta(event,'he-feature__meta'));
        const link=this.link(event);if(link)feature.append(link);
      }
      openDay(date,events) {
        this.dialog.querySelector('h2').textContent=this.format(date,{weekday:'long',day:'numeric',month:'long',year:'numeric'});
        this.querySelector('[data-dialog-list]').replaceChildren(...events.map(event=>this.eventRow(event)));
        this.dialog.showModal();
      }
      render() {
        const isCalendar=this.view==='calendar';
        this.querySelectorAll('[data-view]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.view===this.view)));
        this.querySelector('.he-month').hidden=!isCalendar;
        this.querySelector('[data-calendar]').hidden=!isCalendar;
        this.querySelector('[data-agenda]').hidden=isCalendar;
        if(!isCalendar){
          const list=this.upcoming().filter(e=>this.filter==='all'||e.game===this.filter).slice(0,24);
          this.querySelector('[data-agenda]').replaceChildren(...(list.length?list.map(e=>this.eventRow(e)):[this.node('p','he-empty',this.filter==='all'?this.words.no_upcoming:this.words.empty_filter)]));
          this.querySelector('[data-status]').textContent=list.length?this.words.event_count.replace('{count}',list.length):'';
          return;
        }
        const first=this.date(this.month+'-01');const last=new Date(first);last.setUTCMonth(last.getUTCMonth()+1,0);
        const list=this.occurrences(this.iso(first),this.iso(last)).filter(e=>this.filter==='all'||e.game===this.filter);
        this.querySelector('[data-month-title]').textContent=this.format(this.iso(first),{month:'long',year:'numeric'});
        const week=this.querySelector('[data-weekdays]');week.replaceChildren();
        for(let i=0;i<7;i++)week.append(this.node('span','',this.format('2026-01-'+String(5+i).padStart(2,'0'),{weekday:'short'})));
        const grid=this.querySelector('[data-grid]');grid.replaceChildren();const offset=(first.getUTCDay()+6)%7;
        const total=Math.ceil((offset+last.getUTCDate())/7)*7;
        for(let i=0;i<total;i++){
          const day=i-offset+1;if(day<1||day>last.getUTCDate()){const blank=this.node('div','he-day');blank.setAttribute('aria-hidden','true');grid.append(blank);continue;}
          const date=this.month+'-'+String(day).padStart(2,'0');const events=list.filter(e=>e.date===date);const cell=this.node(events.length?'button':'div','he-day');
          cell.append(this.node('span','he-day__number',String(day)));
          if(date===this.today){cell.classList.add('is-today');cell.setAttribute('aria-current','date');}
          if(date<this.today)cell.classList.add('is-past');
          if(events.length){
            cell.type='button';cell.classList.add('has-events');cell.setAttribute('aria-label',this.format(date,{weekday:'long',day:'numeric',month:'long',year:'numeric'})+': '+events.map(e=>[e.time,e.title].filter(Boolean).join(' ')).join(', '));
            cell.append(this.node('span','he-day__title',events.map(e=>[e.time,e.title].filter(Boolean).join(' ')).join(' / ')));
            cell.append(this.node('span','he-day__count',this.words.calendar_count.replace('{count}',events.length)));
            cell.addEventListener('click',()=>this.openDay(date,events));
          }
          grid.append(cell);
        }
        this.querySelector('[data-status]').textContent=list.length?this.words.event_count.replace('{count}',list.length):this.words.empty_month;
      }
    }
    customElements.define('hot-events',HotEvents);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hot-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('home-product-rail')) {
    customElements.define('home-product-rail', class extends HTMLElement {
      connectedCallback() {
        const track = this.querySelector('.hh-rail');
        const controls = this.querySelector('.hh-rail-controls');
        const buttons = Array.from(controls.querySelectorAll('button'));
        this.abort = new AbortController();
        const signal = this.abort.signal;
        const update = () => {
          const max = track.scrollWidth - track.clientWidth;
          const pos = Math.abs(track.scrollLeft);
          controls.hidden = max < 3;
          buttons[0].disabled = pos < 3;
          buttons[1].disabled = pos >= max - 3;
        };
        buttons.forEach(button => button.addEventListener('click', () => {
          const card = track.querySelector('li');
          if (!card) return;
          const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          const rtl = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
          track.scrollBy({left:(card.getBoundingClientRect().width + gap) * Number(button.dataset.direction) * rtl,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        },{signal}));
        track.addEventListener('scroll',update,{passive:true,signal});
        this.resize = new ResizeObserver(update);
        this.resize.observe(track);
        update();

        this.tiltMedia = matchMedia('(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)');
        this.tiltFrames = Array.from(this.querySelectorAll('.hh-product__image'));
        this.resetTilt = () => {
          cancelAnimationFrame(this.tiltFrame);
          this.tiltFrames.forEach(frame => {
            frame.classList.remove('is-tilting');
            frame.style.removeProperty('--hh-tilt-x');
            frame.style.removeProperty('--hh-tilt-y');
            frame.style.removeProperty('--hh-tilt-scale');
          });
        };
        this.tiltFrames.forEach(frame => {
          frame.addEventListener('pointermove', event => {
            if (!this.tiltMedia.matches || event.pointerType === 'touch') return;
            const bounds = frame.getBoundingClientRect();
            if (!bounds.width || !bounds.height) return;
            const x = Math.max(-1, Math.min(1, ((event.clientX - bounds.left) / bounds.width - .5) * 2));
            const y = Math.max(-1, Math.min(1, ((event.clientY - bounds.top) / bounds.height - .5) * 2));
            cancelAnimationFrame(this.tiltFrame);
            this.tiltFrame = requestAnimationFrame(() => {
              frame.classList.add('is-tilting');
              frame.style.setProperty('--hh-tilt-x', (-y * 18).toFixed(2) + 'deg');
              frame.style.setProperty('--hh-tilt-y', (x * 18).toFixed(2) + 'deg');
              frame.style.setProperty('--hh-tilt-scale', '1.06');
            });
          }, {passive:true,signal});
          frame.addEventListener('pointerleave', this.resetTilt, {signal});
          frame.addEventListener('pointercancel', this.resetTilt, {signal});
        });
        this.tiltMedia.addEventListener('change', this.resetTilt, {signal});
        track.addEventListener('scroll', this.resetTilt, {passive:true,signal});
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.resize?.disconnect();
        this.resetTilt?.();
      }
    });
  }

  if (!customElements.get('home-hero-gallery')) {
    customElements.define('home-hero-gallery', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.slides = Array.from(this.querySelectorAll('[data-hero-slide]'));
        this.stage = this.querySelector('.hh-hero-gallery__stage');
        this.button = this.querySelector('.hh-hero-gallery__toggle');
        this.index = 0;
        this.interval = Math.max(5000, Number(this.dataset.interval) || 6000);
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.tiltMedia = matchMedia('(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)');
        this.userPaused = false;
        this.hovered = false;
        this.focused = false;
        this.touched = false;
        this.inView = false;
        this.pointerActive = false;
        this.pointerX = 0;
        this.pointerY = 0;
        this.motionTime = 0;
        this.lastMotionTime = 0;
        this.motionFrame = null;
        this.pose = {x:-5,y:-12,z:-2,lift:0,scale:1.025};
        this.button.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.sync();
        }, {signal});
        this.stage.addEventListener('pointerenter', event => {
          if (event.pointerType === 'touch') return;
          this.hovered = true;
          this.sync();
        }, {signal});
        this.stage.addEventListener('pointerleave', () => {
          this.hovered = false;
          this.resetTilt();
          this.sync();
        }, {signal});
        this.stage.addEventListener('pointerdown', () => {
          this.touched = true;
          this.sync();
        }, {signal});
        const release = () => {
          this.touched = false;
          this.sync();
        };
        window.addEventListener('pointerup', release, {signal});
        this.stage.addEventListener('pointercancel', release, {signal});
        this.stage.addEventListener('focusin', () => {
          this.focused = true;
          this.sync();
        }, {signal});
        this.stage.addEventListener('focusout', () => {
          cancelAnimationFrame(this.focusFrame);
          this.focusFrame = requestAnimationFrame(() => {
            this.focused = this.stage.contains(document.activeElement);
            this.sync();
          });
        }, {signal});
        this.stage.addEventListener('pointermove', event => {
          if (!this.tiltMedia.matches || event.pointerType === 'touch') return;
          const frame = this.slides[this.index]?.querySelector('.hh-hero__object');
          if (!frame || !frame.contains(event.target)) { this.resetTilt(); return; }
          const bounds = frame.getBoundingClientRect();
          const image = frame.querySelector('img');
          const width = image?.offsetWidth || bounds.width;
          const height = image?.offsetHeight || bounds.height;
          this.pointerX = Math.max(-1, Math.min(1, (event.clientX - bounds.left - bounds.width / 2) / (width / 2)));
          this.pointerY = Math.max(-1, Math.min(1, (event.clientY - bounds.top - bounds.height / 2) / (height / 2)));
          this.pointerActive = true;
        }, {passive:true,signal});
        this.motion.addEventListener('change', () => { this.resetTilt(); this.sync(); }, {signal});
        this.tiltMedia.addEventListener('change', () => this.resetTilt(), {signal});
        document.addEventListener('visibilitychange', () => this.sync(), {signal});
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries.some(entry => entry.isIntersecting);
          this.sync();
        }, {threshold:0.2});
        this.observer.observe(this);
        this.preloadNext();
        this.sync();
      }
      resetTilt() {
        this.pointerActive = false;
        this.pointerX = 0;
        this.pointerY = 0;
      }
      syncMotion() {
        const running = this.isConnected && this.inView && !document.hidden && !this.motion.matches && !this.userPaused && !this.focused;
        if (!running) {
          cancelAnimationFrame(this.motionFrame);
          this.motionFrame = null;
          this.lastMotionTime = 0;
          this.classList.remove('is-animating');
          return;
        }
        if (this.motionFrame !== null) return;
        this.classList.add('is-animating');
        const animate = now => {
          const elapsed = this.lastMotionTime ? Math.min(now - this.lastMotionTime, 50) : 16;
          this.lastMotionTime = now;
          this.motionTime += elapsed / 1000;
          const time = this.motionTime;
          const idleX = Math.sin(time * .9 + .6) * 7 - 3;
          const idleY = Math.sin(time * .65) * 15 - 5;
          const target = this.pointerActive
            ? {x:-this.pointerY * 30 + idleX * .15,y:this.pointerX * 30 + idleY * .15,z:this.pointerX * 2,lift:-6,scale:1.06}
            : {x:idleX,y:idleY,z:Math.sin(time * .5) * 2,lift:Math.sin(time * .8) * 8,scale:1.025};
          const easing = 1 - Math.exp(-elapsed / 130);
          for (const key of Object.keys(this.pose)) this.pose[key] += (target[key] - this.pose[key]) * easing;
          this.style.setProperty('--hero-tilt-x', this.pose.x.toFixed(2) + 'deg');
          this.style.setProperty('--hero-tilt-y', this.pose.y.toFixed(2) + 'deg');
          this.style.setProperty('--hero-tilt-z', this.pose.z.toFixed(2) + 'deg');
          this.style.setProperty('--hero-lift', this.pose.lift.toFixed(2) + 'px');
          this.style.setProperty('--hero-tilt-scale', this.pose.scale.toFixed(3));
          this.motionFrame = requestAnimationFrame(animate);
        };
        this.motionFrame = requestAnimationFrame(animate);
      }
      canPlay() {
        return this.isConnected && this.slides.length > 1 && !this.userPaused && !this.motion.matches && !this.hovered && !this.focused && !this.touched && this.inView && !document.hidden;
      }
      preloadNext() {
        if (this.slides.length < 2) return;
        const image = this.slides[(this.index + 1) % this.slides.length].querySelector('img');
        if (image) image.loading = 'eager';
      }
      sync() {
        clearTimeout(this.timer);
        clearTimeout(this.swapTimer);
        this.stage.classList.remove('is-switching');
        this.button.hidden = this.motion.matches;
        this.button.textContent = this.userPaused ? this.button.dataset.play : this.button.dataset.pause;
        this.button.setAttribute('aria-label', this.userPaused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel);
        this.syncMotion();
        this.schedule();
      }
      schedule(delay = this.interval) {
        clearTimeout(this.timer);
        if (this.canPlay()) this.timer = setTimeout(() => this.advance(), delay);
      }
      advance() {
        if (!this.canPlay()) return;
        const nextIndex = (this.index + 1) % this.slides.length;
        const next = this.slides[nextIndex];
        const image = next.querySelector('img');
        if (image && !image.complete) { this.schedule(1000); return; }
        if (image && !image.naturalWidth) {
          this.slides.splice(nextIndex, 1);
          if (nextIndex < this.index) this.index--;
          this.preloadNext();
          this.sync();
          return;
        }
        this.resetTilt();
        this.stage.classList.add('is-switching');
        this.swapTimer = setTimeout(() => {
          if (!this.canPlay()) { this.stage.classList.remove('is-switching'); return; }
          this.slides[this.index].hidden = true;
          next.hidden = false;
          this.index = nextIndex;
          this.stage.classList.remove('is-switching');
          this.preloadNext();
          this.schedule();
        }, 220);
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        clearTimeout(this.timer);
        clearTimeout(this.swapTimer);
        cancelAnimationFrame(this.focusFrame);
        cancelAnimationFrame(this.motionFrame);
        this.motionFrame = null;
        this.resetTilt();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hot-sealed-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hot-sealed-slider')) {
    customElements.define('hot-sealed-slider', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.hot-sealed__track');
        if (!this.track) return;
        this.controls = this.querySelector('.hot-sealed__controls');
        this.buttons = Array.from(this.controls.querySelectorAll('button'));
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.update = () => {
          const max = this.track.scrollWidth - this.track.clientWidth;
          const position = Math.abs(this.track.scrollLeft);
          this.buttons[0].disabled = position < 3;
          this.buttons[1].disabled = position >= max - 3;
          this.controls.hidden = max < 3;
        };
        this.buttons.forEach(button => button.addEventListener('click', () => {
          const card = this.track.querySelector('li');
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const step = card.getBoundingClientRect().width + gap;
          const direction = Number(button.dataset.direction);
          const rtl = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
          this.track.scrollBy({left: step * direction * rtl, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        }, {signal}));
        this.track.addEventListener('scroll', this.update, {passive: true, signal});
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.track);
        this.update();
        this.reveal = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            this.classList.add('hot-sealed--entered');
            this.reveal.disconnect();
          }
        }, {threshold: 0.12});
        this.reveal.observe(this);
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        this.reveal?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
